export const hireGoLangContentArabic = {
  // محتوى Helmet
  helmet: {
    title: "توظيف مطوري Golang | خدمات تطوير Golang",
    description: "وظّف مطوري Golang ذوي الخبرة لتطبيقات سريعة وموثوقة. خدمات تطوير Go متخصصة لحلول حديثة وقابلة للتطوير.",
  },

  // محتوى HirePageBanner
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/Golang.avif)`,
    mainHeading: "وظّف مطوري Golang عن بُعد",
    content: "هل تبحث عن توظيف مطوري Golang؟ نحن نقدم خبراء تم فحصهم مسبقًا لمساعدتك في بناء تطبيقات آمنة وقابلة للتطوير وعالية الأداء—مثالية للشركات الناشئة والمؤسسات الكبرى.",
    btnText: "استشر مطوري Go Lang لدينا",
    bannerList: [
      { list: "متعاقدون مستقلون" },
      { list: "وظائف بدوام كامل" },
      { list: "فرق عالمية" },
    ],
  },

  // محتوى HirePageExperties
  golangExpertise: {
    btnText:"حدد موعدًا لإجراء مكالمة اليوم",
    heading: "خبرتنا في تطوير Golang",
    description: "في Bitsclan، نقدم حلول Golang عالية الأداء مصممة خصيصًا لاحتياجات عملك. سواء كنت بحاجة إلى تطوير واجهات برمجة التطبيقات (API)، أو خدمات الترحيل، أو تطبيقات كاملة النطاق، يضمن مطورونا ذوو الخبرة الكفاءة وقابلية التوسع والأمان.",
    servicesData: [
      {
        title: "استشارات Golang",
        description: "احصل على مشورة الخبراء والتوجيه الاستراتيجي لتحقيق أقصى استفادة من مشاريع Golang الخاصة بك. سيساعدك مطورونا في تخطيط وتنفيذ أفكارك لضمان النجاح.",
        icon: "/images/hire-page-icons/go-lang-1.svg",
      },
      {
        title: "تطوير الويب باستخدام Golang",
        description: "مطورونا ماهرون في بناء تطبيقات ويب قابلة للتطوير وغنية بالميزات باستخدام Golang. سواء كنت تقوم ببناء منصة جديدة أو تحسين منصة موجودة، فإننا نقدم حلولًا قوية وفعالة.",
        icon: "/images/hire-page-icons/go-lang-2.svg",
      },
      {
        title: "تطوير واجهات برمجة التطبيقات (API) باستخدام Golang",
        description: "يتفوق مطورونا في تطوير واجهات برمجة التطبيقات (API) باستخدام Golang، مما يخلق اتصالًا سلسًا بين التطبيقات. يتيح لك ذلك ربط أنظمتك بسهولة وضمان نقل سلس للبيانات.",
        icon: "/images/hire-page-icons/go-lang-3.svg",
      },
      {
        title: "تطوير أنظمة إدارة المحتوى والبوابات",
        description: "ثق بخبرائنا في بناء أنظمة إدارة المحتوى وبوابات الويب القوية والآمنة وسهلة الاستخدام، وكلها مدعومة بـ Golang. نحن ننشئ منصات سهلة الاستخدام وعالية الأداء لتلبية احتياجات عملك.",
        icon: "/images/hire-page-icons/go-lang-4.svg",
      },
      {
        title: "الترحيل إلى Golang",
        description: "يجعل مطورو Golang لدينا الانتقال إلى تطوير تطبيقات Golang سهلاً وسلسًا. يمكننا مساعدتك في ترحيل أنظمتك الحالية إلى Golang دون تعطيل عملياتك.",
        icon: "/images/hire-page-icons/go-lang-5.svg",
      },
      {
        title: "التكامل مع الحلول الموجودة",
        description: "يتمتع فريقنا بخبرة واسعة في دمج تطبيقات Golang مع منصاتك وخدماتك الحالية. سواء كان ذلك لقواعد البيانات أو أدوات الجهات الخارجية أو الأنظمة الأخرى، فإننا نضمن التكامل السلس.",
        icon: "/images/hire-page-icons/go-lang-6.svg",
      },
      {
        title: "حلول التجارة الإلكترونية باستخدام Golang",
        description: "يضمن تطوير حلول التجارة الإلكترونية باستخدام Golang تجربة مستخدم سريعة وآمنة وتفاعلية للغاية. يبني خبراؤنا منصات موثوقة وقابلة للتطوير توفر الأداء الأمثل للمتاجر عبر الإنترنت.",
        icon: "/images/hire-page-icons/go-lang-7.svg",
      },
      {
        title: "دعم وصيانة Golang",
        description: "نقدم خدمات الدعم والصيانة المستمرة لتطبيقات Golang الخاصة بك، مما يضمن بقائها فعالة وآمنة ومحدثة. فريقنا مكرس للحفاظ على تشغيل أنظمتك بسلاسة.",
        icon: "/images/hire-page-icons/go-lang-8.svg",
      },
    ],
  },

  // محتوى DevelopmentPerformance (لماذا تختارنا)
  whyChooseUs: {
    btnText:"توظيف مطور اليوم",
    heading: "لماذا تختارنا لتوظيف ",
    greenHeading: "مطورين Golang",
    subHeading: "في Bitsclan، نجمع بين Golang والتقنيات الحديثة للواجهة الأمامية والخلفية لإنشاء تطبيقات قوية وقابلة للتطوير. سواء كنت تقوم بتطوير منصة ويب أو بنية قائمة على الخدمات المصغرة، يضمن خبراؤنا أداءً سلسًا ودورات تطوير سريعة.",
    solutionsData: [
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "الوصول إلى المواهب المفحوصة",
        description: "عندما تقوم بتوظيف مطوري Golang من خلالنا، فإنك تحصل على خبراء تم فحصهم بدقة لمهاراتهم التقنية وكفاءتهم في اللغة الإنجليزية.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "عرض النتائج في ثوانٍ",
        description: "لا داعي لغربلة أكوام السير الذاتية. باستخدام HireAI، يمكنك عرض واختيار أفضل مطوري Golang للتوظيف الذين يتناسبون مع متطلبات مشروعك على الفور.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "وفّر مع التوظيف العالمي",
        description: "يمكنك الوصول إلى مجموعة عالمية تضم أكثر من 450,000 مطور من 190 دولة. من خلال التوظيف من مجموعة مواهب عالمية، يمكنك توفير ما يصل إلى 58% مقارنةً بطرق التوظيف التقليدية، مع الاستمرار في الحصول على خبرة رفيعة المستوى في تطوير تطبيقات Golang.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "احصل على دعم بشري حقيقي",
        description: "في Bitsclan، أنت لا توظف مطورين فحسب؛ بل تحصل على دعم فريقنا من خبراء التوظيف المكرسين لمساعدتك في العثور على الموهبة المناسبة. كن واثقًا من حصولك على مساعدة حقيقية وعملية طوال العملية.",
      },
    ],
  },

  // محتوى HireCombinationSection
  techCombinations: {
    heading: "أفضل تركيبات تقنية GoLang لتطوير عالي الأداء",
    description: "حقق أقصى قدر من الكفاءة وقابلية التوسع مع أفضل تركيبات تقنية GoLang. وظّف مطوري GoLang خبراء لبناء تطبيقات قوية وعالية الأداء وآمنة مصممة خصيصًا لاحتياجات عملك.",
    combinations: [
      {
        title: "Go + Gin + PostgreSQL",
        description: "Gin، إطار عمل ويب Go خفيف الوزن، مقترنًا بـ PostgreSQL، يوفر حلاً خلفيًا عالي الأداء وقابلاً للتطوير.",
        icons: ["golang.svg", "gin-cae.svg", "postgres.svg"],
      },
      {
        title: "Go + Echo + MySQL",
        description: "Echo، إطار عمل ويب Go سريع وبسيط، مقترنًا بـ MySQL، يتيح التطوير الفعال للتطبيقات القابلة للتطوير.",
        icons: ["golang.svg", "echo-icon.svg", "mysql-whale-icon.svg"],
      },
      {
        title: "Go + Fiber + MongoDB",
        description: "Fiber، إطار عمل Go مستوحى من Express، مقترنًا بـ MongoDB، يضمن تطوير واجهات برمجة التطبيقات عالية السرعة مع تخزين NoSQL مرن.",
        icons: ["golang.svg", "fiber.svg", "mongodb.svg"],
      },
      {
        title: "Go + React + PostgreSQL",
        description: "React لتطوير الواجهة الأمامية الديناميكية، Go لمنطق الواجهة الخلفية الفعال، و PostgreSQL لقاعدة بيانات علائقية موثوقة.",
        icons: ["golang.svg", "react.svg", "postgres.svg"],
      },
      {
        title: "Go + gRPC + Kubernetes",
        description: "Go مع gRPC يتيح اتصالات الخدمات المصغرة الفعالة، بينما يوفر Kubernetes تنظيم الحاويات القابل للتطوير.",
        icons: ["golang.svg", "grpc.svg", "kubernetes.svg"],
      },
      {
        title: "Go + GraphQL + AWS",
        description: "Go لمنطق الواجهة الخلفية، GraphQL لاستعلامات واجهة برمجة التطبيقات المرنة، و AWS لحلول الحوسبة السحابية والتخزين القابلة للتطوير.",
        icons: ["golang.svg", "graphql.svg", "aws.svg"],
      },
    ],
  },

  // محتوى HirePageSteps
  hireSteps: {
    btnText:"دعنا نجد المطور المثالي لك",
    heading: "وظّف مطوري Golang في 4 خطوات سهلة",
    subHeading: "في Bitsclan، نجعل من السهل توظيف مطوري Golang من خلال عملية مباشرة من 4 خطوات. نركز على التأكد من حصولك على الموهبة المناسبة لمشروعك، بسرعة وفعالية.",
    steps: [
      {
        title: "اختر نموذج التعاقد الخاص بك",
        description: "اختر نموذج التعاقد الذي يناسب احتياجاتك بشكل أفضل - سواء كان دوامًا كاملاً أو جزئيًا أو بالساعة. تضمن هذه المرونة حصولك على الدعم الذي تحتاجه بناءً على متطلبات مشروعك.",
        icon: "/images/hire-page-setps-icons/icon-1.svg"
      },
      {
        title: "فحص واختيار مطوري Golang",
        description: "تصفح ملفات تعريف مطوري Go للتوظيف واختر المرشحين الذين يتناسبون بشكل أفضل مع احتياجات مشروعك. اختر بناءً على المهارات والخبرة والكفاءة.",
        icon: "/images/hire-page-setps-icons/icon-2.svg"
      },
      {
        title: "إجراء مقابلة فردية",
        description: "قابل المرشحين المختارين لتقييم مهاراتهم. يمكنك اختبارهم بأسئلة نظرية وعملية للتأكد من أنهم مناسبون تمامًا.",
        icon: "/images/hire-page-setps-icons/icon-3.svg"
      },
      {
        title: "إعداد مطوري Golang",
        description: "بمجرد اتخاذ قرارك النهائي، سينضم مطور Golang المختار إلى فريقك في غضون 24-48 ساعة. يضمن ذلك انتقالًا سلسًا وتقدمًا سريعًا للمشروع.",
        icon: "/images/hire-page-setps-icons/icon-4.svg"
      }
    ],
  },

  // محتوى CoverTheStack
 coverTheStack: {
  whereStart: "إطار العمل",
  mainHeading: "عزّز تطوير الويب لديك باستخدام حلول Golang عالية الأداء",
  subHeading:
    "في Bitsclan، ندعم رحلة تطوير الويب الخاصة بك باستخدام حزمة تقنيات Golang القوية التي تضمن الكفاءة وقابلية التوسع والسرعة. يستفيد مطورونا الخبراء في Golang من التقنيات الحديثة لبناء تطبيقات ويب قوية وعالية الأداء مصممة خصيصًا لاحتياجات عملك.",
  tabs: [
    "إطار العمل",
    "حزمة",
    "قاعدة بيانات",
    "الخدمات السحابية",
    "الأدوات",
    "الاتصالات",
  ],
  tabItems: [
      { tab: "إطار العمل", icon: "/images/tech-stack-icons/gin-cae.svg", name: "Gin" },
      { tab: "إطار العمل", icon: "/images/tech-stack-icons/echo-icon.svg", name: "Echo" },
      { tab: "إطار العمل", icon: "/images/tech-stack-icons/beego-icon.svg", name: "Beego" },
      { tab: "إطار العمل", icon: "/images/tech-stack-icons/revel-icon.png", name: "Revel" },
      { tab: "إطار العمل", icon: "/images/tech-stack-icons/buffalo-icon.svg", name: "Buffalo" },
      { tab: "إطار العمل", icon: "/images/tech-stack-icons/goa-icon.svg", name: "Goa" },
      { tab: "إطار العمل", icon: "/images/tech-stack-icons/fiber.svg", name: "Fiber" },
      { tab: "إطار العمل", icon: "/images/tech-stack-icons/chi-icon.svg", name: "Chi" },
      { tab: "إطار العمل", icon: "/images/tech-stack-icons/image-icon.svg", name: "Google Protobuf" },

      { tab: "حزمة", icon: "/images/tech-stack-icons/chi-icon.svg", name: "Chi" },
      { tab: "حزمة", icon: "/images/tech-stack-icons/stringer-icon.svg", name: "Stringer" },
      { tab: "حزمة", icon: "/images/tech-stack-icons/gorilla-icon.svg", name: "Gorilla Mux" },
      { tab: "حزمة", icon: "/images/tech-stack-icons/gorm-icon.svg", name: "GORM" },

      { tab: "قاعدة بيانات", icon: "/images/db5.png", name: "MySQL" },
      { tab: "قاعدة بيانات", icon: "/images/db3.png", name: "MongoDB" },
      { tab: "قاعدة بيانات", icon: "/images/tech-stack-icons/redis.svg", name: "Redis" },
      { tab: "قاعدة بيانات", icon: "/images/tech-stack-icons/postgres.svg", name: "Postgres" },
      { tab: "قاعدة بيانات", icon: "/images/tech-stack-icons/elasticsearch.svg", name: "ElasticSearch" },

      { tab: "الخدمات السحابية", icon: "/images/devops3.png", name: "Docker" },
      { tab: "الخدمات السحابية", icon: "/images/cloud3.png", name: "AWS" },
      { tab: "الخدمات السحابية", icon: "/images/cloud2.png", name: "Azure" },
      { tab: "الخدمات السحابية", icon: "/images/cloud1.png", name: "Google Cloud" },
      { tab: "الخدمات السحابية", icon: "/images/tech-stack-icons/digital-ocean.svg", name: "Digital Ocean" },

      { tab: "الأدوات", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
      { tab: "الأدوات", icon: "/images/tech-stack-icons/postgres.svg", name: "PG Admin" },
      { tab: "الأدوات", icon: "/images/tech-stack-icons/git-hub.svg", name: "Git" },
      { tab: "الأدوات", icon: "/images/tech-stack-icons/gitlab.svg", name: "gitlab" },

      { tab: "الاتصالات", icon: "/images/tech-stack-icons/rest-apis.svg", name: "Rest APIs" },
      { tab: "الاتصالات", icon: "/images/tech-stack-icons/grpc.svg", name: "gRPC" },
      { tab: "الاتصالات", icon: "/images/tech-stack-icons/sockets.svg", name: "Web Sockets" },
      { tab: "الاتصالات", icon: "/images/tech-stack-icons/graph.svg", name: "GraphQl" },
      { tab: "الاتصالات", icon: "/images/tech-stack-icons/apache.svg", name: "Apache" },
      { tab: "الاتصالات", icon: "/images/tech-stack-icons/kafka.svg", name: "Kafka" },
      { tab: "الاتصالات", icon: "/images/tech-stack-icons/rabbit.svg", name: "RabbitMQ" },
    ],
  },

  // محتوى HireExpertFacts
  expertFacts: {
    btnText:"حجز موعد",
    heading: "حقائق سريعة حول ",
    greenHeading: "فريق Golang لدينا",
    facts: [
      { text: "لدينا فريق يضم أكثر من 40 مطور Golang ذو خبرة." },
      { text: "متوسط خبرة مطورينا هو 25.98 سنة." },
      { text: "يتمتع مطورونا بخبرة واسعة في تطوير تطبيقات Golang." },
      { text: "نعتمد على ثقافة DevOps ناضجة لسير العمل بسلاسة." },
      { text: "نحن متخصصون في الحلول القابلة للتطوير باستخدام Golang والتطوير السحابي الأصلي." },
      { text: "يتمتع فريقنا بخبرة في البيانات الضخمة، وإنترنت الأشياء، والتعلم الآلي، وتقنية blockchain." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-golang-arabic.avif)`
  },

  // محتوى HirePageAppIdea
  appIdeaSection: {
    heading: "لست متأكدًا من فكرة تطبيقك؟ احصل على النموذج الأولي خلال 6 إلى 8 أسابيع!",
    content: "هل لديك فكرة ولكنك غير متأكد من كيفية المتابعة؟ يمكن لخبراء Golang لدينا مساعدتك في بناء نموذج أولي وظيفي في غضون 6-8 أسابيع فقط! تحقق من رؤيتك، واختبر تفاعل المستخدم، وأنشئ أساسًا قويًا للنجاح من خلال خدمات التطوير المتخصصة لدينا.",
  },

  // خصائص مكون HirePageEngagementModels
  hirePageEngagementModels: {
    btnText:"ابدأ الآن",
    headingContent: [
      { text: "نماذج التعاقد" },
      { text: "المرنة لدينا" },
    ],
    discription: "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل أو جزئي أو بالساعة، فإننا نقدم خيارات مرنة لضمان التعاون السلس والحد الأقصى من الكفاءة طوال مشروعك.",
    hiringDetails: [
      {
        text: "التعاقد بالساعة",
        hours: "48",
        timeUnit: "ساعة",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ العمل في غضون "
      },
      {
        text: "التعاقد بدوام كامل",
        hours: "72",
        timeUnit: "ساعة",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ في غضون "
      },
      {
        text: "التعاقد بدوام جزئي",
        hours: "48",
        timeUnit: "ساعة",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "انطلق في غضون "
      },
    ],
  },

  // محتوى SecondFaq
  faqSection: {
    mainHeading: "الأسئلة الشائعة",
    subHeading: "استكشف خدمات تطوير Golang لدينا لحلول الويب المخصصة وإنشاء واجهات برمجة التطبيقات وإدارة النشر!",
    faqData: [
      {
        id: "collapseOne",
        question: "لماذا يجب أن أوظف مطوري Golang من Bitsclan؟",
        answer: "في Bitsclan، نحن متخصصون في تقديم خدمات تطوير Golang عالية الجودة. فريقنا ماهر في بناء تطبيقات قابلة للتطوير وآمنة وعالية الأداء تلبي احتياجات عملك.",
      },
      {
        id: "collapseTwo",
        question: "كم يستغرق إعداد مطور Golang؟",
        answer: "بمجرد اختيارك للمطور، سينضم إلى فريقك في غضون 24-48 ساعة. نحن نضمن عملية إعداد سلسة وسريعة لبدء مشروعك بسرعة.",
      },
      {
        id: "collapseThree",
        question: "ما هو مستوى خبرة مطوري Golang لديكم؟",
        answer: "يتمتع مطورونا في Golang بمتوسط خبرة يزيد عن 25 عامًا، مما يضمن خبرة رفيعة المستوى في تطوير تطبيقات Golang.",
      },
      {
        id: "fourth",
        question: "هل يمكنك المساعدة في ترحيل أنظمتي الحالية إلى Golang؟",
        answer: "نعم، خبراؤنا ملمون جيدًا بترحيل الأنظمة الموجودة بسلاسة إلى Golang، مما يضمن الحد الأدنى من التوقف عن العمل وانتقالًا سلسًا.",
      },
      {
        id: "fifth",
        question: "ما هي أنواع المشاريع التي يمكنك التعامل معها باستخدام Golang؟",
        answer: "نقدم خدمات تطوير Golang لمجموعة واسعة من المشاريع، بما في ذلك تطبيقات الويب، وواجهات برمجة التطبيقات (APIs)، وأنظمة إدارة المحتوى (CMS)، ومنصات التجارة الإلكترونية، والمزيد.",
      },
      {
        id: "sixth",
        question: "كيف أختار أفضل مطور Golang لمشروعي؟",
        answer: "يمكنك مراجعة ملفات تعريف مطوري Go للتوظيف، وإجراء المقابلات، وتقييم مهاراتهم بناءً على احتياجات مشروعك. تضمن عمليتنا أنك ستجد أفضل تطابق لمتطلباتك.",
      },
    ],
  },
};